<span class="player-stats-text">{{ playerStatsData.statsText }}</span>
<ng-container *ngIf="!isEpcotEnabled; else epcotTemplate">
    <div class="player-stats-value-container">
        <span class="player-stats-value" [msValueSlider]="playerStatsData.statsValue.toString()"></span>
    </div>
</ng-container>
<ng-template #epcotTemplate>
    <div class="player-stats-value-container" [ngClass]="statsIndicator">
        <span class="player-stats-value">{{ playerStatsData.statsValue }}</span>
    </div>
</ng-template>
